import { Route, Switch } from 'react-router-dom';
import { Supporters } from './Supporters';
import { EditCampaign } from './EditCampaign';
import { CampaignUpdates } from './CampaignUpdates';
import { CampaignGuestbook } from './CampaignGuestbook';
import { CampaignFiles } from './CampaignFiles';
import { Grants } from './Grants';
import { useContext } from 'react';
import { GrantsContext } from '~/context/grants';

export const CampaignIndex = () => {
  const [grants] = useContext(GrantsContext);

  return (
    <Switch>
      <Route path='/campaign/supporters/donations' component={Supporters} />
      <Route path='/campaign/edit' component={EditCampaign} />
      <Route path='/campaign/updates' component={CampaignUpdates} />
      <Route path='/campaign/guestbook' component={CampaignGuestbook} />
      <Route path='/campaign/files' component={CampaignFiles} />
      {grants?.grants?.length && (
        <Route path='/campaign/supporters/grants' component={Grants} />
      )}
    </Switch>
  );
};
